import { FC } from 'react';
import { cn } from '@/lib/utils';
import {
  BookOpenTextIcon,
  FilePen,
  FileText,
  Notebook,
  NotepadTextIcon,
  PlayCircleIcon,
} from 'lucide-react';

const ContentType: FC<{ type: string; className?: string }> = ({
  type,
  className,
}) => {
  if (type.toLowerCase() === 'notebook'.toLowerCase())
    return <Notebook className={cn('', className)} size={24} />;

  if (type.toLowerCase() === 'pdf'.toLowerCase() || type.toLowerCase() === 'slides'.toLowerCase())
    return <FileText className={cn('', className)} size={24} />;

  if (type.toLowerCase() === 'reading'.toLowerCase())
    return <BookOpenTextIcon className={cn('', className)} size={24} />;

  if (type.toLowerCase() === 'quiz'.toLowerCase())
    return <NotepadTextIcon className={cn('', className)} size={24} />;

  if (type.toLowerCase() === 'video'.toLowerCase())
    return <PlayCircleIcon className={cn('', className)} size={24} />;

  if (type.toLowerCase() === 'assignment'.toLowerCase())
    return <FilePen className={cn('', className)} size={24} />;

  return '';
};

export default ContentType;
